<template>
  <div class="mb-3">
    <label for="email" class="form-label"> {{ $t("auth.login.email") }}</label>
    <input
      type="email"
      :placeholder="$t('auth.login.email')"
      autocomplete="off"
      class="form-control"
      v-model="input"
      @keyup="validateInput"
      @blue="validateInput"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <div class="error mt-1 tx-13 text-danger" v-if="errors.email">
      {{ errors.email }}
    </div>
  </div>
</template>
 <script>
import { ref } from "vue";
import useFormValidation from "@/modules/useFormValidation";
export default {
  name: "EmailField",
  setup() {
     let input = ref("");
    const { validateEmailField, errors } = useFormValidation();
    const validateInput = () => {
      validateEmailField("email", input.value);
    };
     return { input, errors, validateInput };
  },
};
</script>